exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".miss-plete {\n  position: relative;\n}\n\n.miss-plete > ul {\n  font-size: 1.5em;\n\n  position: absolute;\n  right: 0;\n  left: 0;\n\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  list-style: none;\n\n  text-align: left;\n\n  border: 1px solid rgba(0,0,0,.3);\n  background-color: white;\n}\n\n.miss-plete > ul > li {\n  padding: .2em .5em;\n}\n\n.miss-plete > ul > li.highlight {\n  cursor: pointer;\n\n  background-color: #ffe3b0;\n}\n\n.miss-plete > ul > li span {\n  color: #777;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/miss-plete.css
 ** module id = 5
 ** module chunks = 0
 **/